import StaticContentPage from "./StaticContentPage";

const PrivacyPolicy = () => (
  <StaticContentPage slug="privacy-policy" title="Privacy Policy" />
);

export default PrivacyPolicy;
